exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3pmK {\n  position: absolute;\n  height: 187px;\n  width: 151px;\n  border-radius: 2px;\n  background-color: #485460;\n  color: #161616;\n  -webkit-box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n          box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  -webkit-transform: translateY(10px);\n      -ms-transform: translateY(10px);\n          transform: translateY(10px); }\n  ._3pmK p {\n    font-size: 12px; }\n\n._2AZE {\n  position: absolute;\n  color: #485460;\n  font-size: 35px;\n  top: -22px;\n  left: 35px; }\n\n._3ePg {\n  height: 16px;\n  width: 14px; }\n\n._1iNk {\n  color: #F8F8F8;\n  margin: 20px 0px 5px 20px; }\n\n._3CWI {\n  -webkit-transition: 2s all;\n  -o-transition: 2s all;\n  transition: 2s all; }\n", ""]);

// exports
exports.locals = {
	"dropdownBox": "_3pmK",
	"caretUp": "_2AZE",
	"icon": "_3ePg",
	"header": "_1iNk",
	"listOpenIcon": "_3CWI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import /"variables/";","includePaths":["/app/src/styles"]}!./src/pages/Admin/components/Dropdown/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"namedExport":true,"localIdentName":"[hash:base64:4]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"data":"@import \"variables\";","includePaths":["/app/src/styles"]}!./src/pages/Admin/components/Dropdown/styles.scss
// module chunks = 0